import { getCurrentLanguage } from '../../containers/LanguageSwitcher/config';
import AppLocale from '../../languageProvider';
const actions = {
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  ACTIVATE_LANG_MODAL: 'ACTIVATE_LANG_MODAL',
  switchActivation: () => ({
    type: actions.ACTIVATE_LANG_MODAL
  }),
  changeLanguage: language => {
    return {
      type: actions.CHANGE_LANGUAGE,
      language: getCurrentLanguage(language),
      messages:AppLocale[getCurrentLanguage(language).locale]
    };
  }
};
export default actions;
